import request from '@/util/request';
import qs from 'qs';

// 获取音频列表
export const getAudioListApi = (params, options) =>
  request.get('/api/v4ward/plan/page', Object.assign({}, options, { params }));

// 新增音频文件
export const addAudioApi = (params, options) =>
  request.post('/api/fixme', params, options, {
    'Content-Type': 'application/json',
  });

// 音频文件
export const delAudioApi = (params, options) =>
  request.post('/api/fixme', qs.stringify(params), options);

// 保存规则
export const saveRuleApi = (params, options) =>
  request.post('/api/fixme', params, options, {
    'Content-Type': 'application/json',
  });
